
import DollarSquare from "../../../assets/outline/DollarSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DollarSquareIcon({ className, dataTestid = "DollarSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DollarSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
